import React from 'react';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';

function ButtonFilter({ onClick, filterType, selectedValue }) {
  // Define the button values based on the filter type
  const buttonValues =
    filterType === 'roi' ? ['All', 5, 10, 15, 20, 25] :
    filterType === 'appreciation' ? ['All', 0, 5, 10, 15, 20] :
    filterType === 'score' ? ['All', 5, 10, 15, 20, 25] : [];

  return (
    <ButtonGroup aria-label="Basic example">
      {buttonValues.map((value) => (
        <Button
          variant="light"
          onClick={() => onClick(value, filterType)}  // Pass the value and filter type
          key={value}
          className={selectedValue === value ? 'active' : ''}  // Highlight selected button
        >
         {value === 'All' ? value : filterType !== 'score' ? `${value}%` : `${value}+`}  
        </Button>
      ))}
    </ButtonGroup>
  );
}

export default ButtonFilter;
